/**
 * Spreadsheet formula-injection guard (AB#6304, OWASP "CSV Injection").
 *
 * Excel, LibreOffice and Google Sheets evaluate a cell as a formula when its first
 * character is `=`, `+`, `-` or `@` (and a leading tab / carriage return can be
 * stripped before that check). Wrapping the cell in CSV quotes does NOT prevent this:
 * the quotes are removed on import and the content is evaluated, so a cell such as
 * `=HYPERLINK("http://attacker","x")` becomes a live link.
 *
 * Prefixing a single quote makes the spreadsheet treat the cell as literal text. Per
 * OWASP this is applied to EVERY cell starting with one of those characters,
 * including plain negative numbers such as `-3` -- they then open as text rather
 * than as a number, which is the accepted trade-off for a safe export.
 *
 * Apply it to the raw cell value BEFORE any CSV quoting/escaping.
 */
const FORMULA_TRIGGER = /^[=+\-@\t\r]/

export const neutralizeCsvCell = (value: string): string =>
  FORMULA_TRIGGER.test(value) ? `'${value}` : value
